export default "__VITE_ASSET__DGDK2iMu__";